
const tab_definitions = [
  { id: "kalshi_markets", label: "Kalshi markets" },
  { id: "kalshi_events", label: "Kalshi events" },
  { id: "polymarket_markets", label: "Polymarket markets" },
  { id: "polymarket_events", label: "Polymarket events" },
]

const DiscoverTabs = ({ active_tab, set_active_tab }) => {
  return (
    <div className="mt-0 border-b border-gray-200">
      <nav className="-mb-px flex flex-wrap gap-2" aria-label="Discover tabs">
        {tab_definitions.map((tab) => {
          const is_active = tab.id === active_tab
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => set_active_tab(tab.id)}
              className={
                is_active
                  ? "border-b-2 border-blue-600 px-3 py-2 text-sm font-semibold text-blue-600"
                  : "border-b-2 border-transparent px-3 py-2 text-sm font-semibold text-gray-500 hover:border-gray-300 hover:text-gray-700"
              }
            >
              {tab.label}
            </button>
          )
        })}
      </nav>
    </div>
  )
}

export default DiscoverTabs
